import { Modal, Button, Table, notification } from 'antd'
import axios from 'axios'
import React, { useState, useEffect } from 'react'
import _ from "lodash";
import { CheckCircleTwoTone, SyncOutlined, WarningTwoTone } from '@ant-design/icons';
import baseUrl from '../../config';
import { useTranslation } from 'react-i18next';

const BelirsizListModal = ({
    modalOpenBelirsiz,
    setModalOpenBelirsiz,
    modifiedDataBelirsiz,
}) => {
    const { t } = useTranslation();
    const [api, contextHolder] = notification.useNotification();
    const openNotification = (placement, value, icon) => {
        api.info({
            message: t('constraint.systemInfo'),
            description: `${value}`,
            placement,
            icon: icon || <CheckCircleTwoTone twoToneColor="#52c41a" />,
        });
    };

    // const [loading, setLoading] = useState(false)
    const [sortedInfo, setSortedInfo] = useState({});
    const [filteredInfo, setFilteredInfo] = useState({});
    const [currentTable, setCurrentTable] = useState([])
    const [modifiedData, setModifiedData] = useState([])
    const [selectedRowsData, setSelectedRowsData] = useState([])

    const handleChange = (pagination, filters, sorter, currentTable) => {
        // console.log('Various parameters', pagination, filters, sorter);
        setFilteredInfo(filters);
        setSortedInfo(sorter);
        setCurrentTable(currentTable?.currentDataSource)

    };


    const filterData = data => formatter => currentTable.length > 0 ? currentTable.map(item => ({
        text: formatter(item),
        value: formatter(item)
    })) : modifiedData.map(item => ({
        text: formatter(item),
        value: formatter(item)
    }));

    useEffect(() => {
        const dataList = modifiedDataBelirsiz?.map((item, index) => ({
            key: index + 1,
            date: item?.date,
            finishTime: item?.finishTime,
            machine: item?.machine,
            startTime: item?.startTime,
            parcatanimi: item?.parcatanimi,
            target: item?.target,
            panelcode: item?.panelcode,
            id: item?.id

        }));

        setModifiedData([...dataList]);
    }, [modifiedDataBelirsiz]);

    const columns = [
        {
            title: t('table.startTime'),
            dataIndex: 'startTime',
            key: 'startTime',
            filters: _.uniqWith(filterData(modifiedData)(i => i.startTime), _.isEqual),
            filteredValue: filteredInfo.startTime || null,
            onFilter: (value, record) => record.startTime === value,
            sorter: (a, b) => a.startTime.localeCompare(b.startTime),
            sortOrder: sortedInfo.columnKey === 'startTime' ? sortedInfo.order : null,
            width: 150,
        },
        {
            title: t('table.machine'),
            dataIndex: 'machine',
            key: 'machine',
            width: 150,
        },
    ];
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            // console.log( 'selectedRows: ', selectedRows);
            setSelectedRowsData(selectedRows)
        },
        // getCheckboxProps: (record) => ({
        //     disabled: record.name === 'Disabled User',
        //     // Column configuration not to be checked
        //     name: record.name,
        // }),
    };

    const handleSubmit = (e) => {
        e.preventDefault()
        axios.post(`${baseUrl}/returnIds`, ({ selectedId: selectedRowsData.map(item => item.id) }))
            .then(res => {
                if (res.status === 200) {
                    setModalOpenBelirsiz(false)
                    openNotification('top', 'Gönderildi.')
                }
                if (res.status === 201) {
                    openNotification('top', res.data, <WarningTwoTone twoToneColor="red" />)

                }
            });
        // console.log({ belirsiz: allData.belirsiz, machine: allData.machine, start: dateStart === "" ? Date(Date.now()) : dateStart, end: dateEnd === "" ? Date(Date.now()) : dateEnd })
    }

    return (
        <>
            {contextHolder}

            <Modal
                title={t('constraint.uncertainList')}
                centered
                open={modalOpenBelirsiz}
                onCancel={() => {
                    setModifiedData([])
                    setModalOpenBelirsiz(false)

                }}
                cancelButtonProps={{ style: { display: 'none' } }}
                okButtonProps={{ style: { display: 'none' } }}

            >

                <Table
                    dataSource={modifiedData}
                    columns={columns}
                    pagination={{ pageSize: 6 }}
                    rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
                    sticky
                    // loading={loading}
                    onChange={handleChange}
                    rowSelection={{
                        ...rowSelection,
                    }}
                />
                <div className='w-full flex flex-col gap-10 justify-center mt-8'>
                    <div className='flex'>

                    </div>

                    <div className='w-full flex flex-col gap-3 justify-center mt-8'>
                        <Button disabled={selectedRowsData.length===0} onClick={handleSubmit} className='flex justify-center items-center bg-smartoptLogoColor text-white font-bold text-base '>{t('constraint.endSelectedBreakdowns')}</Button>
                    </div>
                </div>
            </Modal>

        </>
    )
}

export default BelirsizListModal